import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Fmarinos202203_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Fmarinos202203_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "神奈川",
    shopUuids: isProduction
      ? ["aFiCDDjQfsdW", "Xv4omhxAY5tg", "j0K8BeKqCzCy"]
      : ["UuidUuidUuid", "UuidUuidUuid", "UuidUuidUuid"],
  },
  {
    prefecture: "東京",
    shopUuids: isProduction
      ? ["8iV23eVO7uoW", "n3uvA2JhwPlL"]
      : ["UuidUuidUuid", "UuidUuidUuid"],
  },
];

type Fmarinos202203PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const Fmarinos202203: NextPage<Fmarinos202203PageProps> = ({
  data,
  prefectures,
}) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={
          "横浜F・マリノスをお店で応援！横浜F・マリノスを観戦できるスポーツバー"
        }
        description={
          "明治安田J1リーグ、AFCチャンピオンズリーグの横浜F・マリノス戦を応援できる横浜、新横浜、久里浜、渋谷、日比谷などのDAZN公式契約スポーツバーをご紹介。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignFmarinos202203}
        ogImage={`${process.env.APP_HOST}/img/campaign/fmarinos-202203/ogp.png`}
        canonicalUrl={paths.campaignFmarinos202203}
      />
      <CampaignTemplate
        teamName="横浜F・マリノス"
        slug="fmarinos-202203"
        leagueName="明治安田J1リーグ"
        teamIds={[8]}
        colorText="トリコロールカラー"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        presentAreaHidden
        sportGenreSlug={"soccer"}
        teamSlug={"fmarinos"}
        specialEventAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default Fmarinos202203;
